/**
 * @module FE-CU47_ユーザー情報変更画面_氏名電話番号
 */
import Header from '../../../components/header/Header.vue';
import BreadCrumbList from '../../../components/breadCrumb/List.vue';
import MobileFooter from '../../../components/footer/MobileFooter.vue';
import PcPageTitle from '@/components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';

const PAGE_ID = 'FE-CU47';

export default {
  name: 'UserNameEdit',
  components: {
    Header,
    BreadCrumbList,
    MobileFooter,
    PcPageTitle,
    PCFooter,
  },
  data() {
    return {
      userInfo: {
        name: '',
        gender: 1,
        birthyear: 1970,
      },
      birthyear: null,
      nameError: '',
      genderError: '',
      birthyearError: '',
      modified: '',
      menu: false,
      pickerDate: '1970-1-1',
      pickerDateMin: '1800',
      pickerDateMax: '2022-NaN-NaN',
      valid: true,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    nameRule() {
      return [
        !!this.userInfo.name ||
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU47ユーザー情報変更画面氏名電話番号.E0001'
          ),
      ];
    },
    disabled() {
      return this.userInfo.name !== '' && this.valid ? false : true;
    },
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t(
          '$vuetify.FECU47ユーザー情報変更画面氏名電話番号.ユーザー情報変更'
        ),
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU47ユーザー情報変更画面氏名電話番号.C0001'
        ),
        genders: [
          {
            value: 1,
            text: vm.$vuetify.lang.t('$vuetify.FECU47ユーザー情報変更画面氏名電話番号.未指定'),
          },
          {
            value: 2,
            text: vm.$vuetify.lang.t('$vuetify.FECU47ユーザー情報変更画面氏名電話番号.男性'),
          },
          {
            value: 3,
            text: vm.$vuetify.lang.t('$vuetify.FECU47ユーザー情報変更画面氏名電話番号.女性'),
          },
        ],
        unspecified: vm.$vuetify.lang.t('$vuetify.FECU47ユーザー情報変更画面氏名電話番号.未指定'),
        birthyearUnspecified: vm.$vuetify.lang.t(
          '$vuetify.FECU53ユーザー登録画面本登録.生年セレクト.未指定'
        ),
      };
    },
    birthyears(vm) {
      const birthyears = [];

      birthyears.push({
        value: null,
        text: vm.$vuetify.lang.t('$vuetify.FECU53ユーザー登録画面本登録.生年セレクト.未指定'),
      });

      const year = new Date().getFullYear();
      for (let i = year; i >= this.CONSTANTS.MIN_BIRTH_YEAR; i--) {
        birthyears.push({
          value: i,
          text: this.$vuetify.lang.t('$vuetify.FECU53ユーザー登録画面本登録.生年セレクト.生年', i),
        });
      }
      return birthyears;
    },
  },
  watch: {
    // v-date-pickerを年指定にする
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'));
    },
    // 初期値が空の場合、未指定にする
    // v-date-pickerの年を変更時に画面設定値を更新する
    pickerDate: {
      handler(newVal, oldVal) {
        if (isNaN(newVal.substr(0, 4))) {
          this.userInfo.birthyear = this.i18nItems.unspecified;
        } else if (newVal != '' && newVal != undefined && newVal != oldVal) {
          this.userInfo.birthyear = Number(newVal.substr(0, 4));
        }
      },
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * APP_CU4701 ユーザー情報取得（氏名）
     * @param {string} param エンドポイント
     * @param {object} queries リクエスト
     * @param {string} method HTTPメソッド
     * @returns {object} レスポンス
     */
    APP_CU4701: async function (param, queries, method) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     userInfo: {
            //       name: "山田太郎",
            //       gender: 2,
            //       birthyear: 1992,
            //     },
            //     modified: "2022-05-09 09:00:00",
            //   },
            // };

            this.userInfo = apiData.contentsInfo.userInfo;
            this.pickerDate = apiData.contentsInfo.userInfo.birthyear + '-1-1';
            this.modified = apiData.contentsInfo.modified;

            this.birthyear = apiData.contentsInfo.userInfo.birthyear;
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * APP_CU4702 ユーザー情報更新（氏名）
     */
    APP_CU4702: async function () {
      this.$_setLoading(true);
      this.userInfo.birthyear = this.birthyear;
      let param = '/api/changeUserInfoOfPersonalData/update';
      // let param = "post";

      let method = 'post';
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        userInfo: this.userInfo,
        modified: this.modified,
      };

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            // apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // レスポンスなし
            this.callMessageDialog(
              '$vuetify.FECU47ユーザー情報変更画面氏名電話番号.変更が完了しました'
            );
          },
          (error) => {
            if (error.message.includes('400')) {
              // エラーダイアログを表示
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU47ユーザー情報変更画面氏名電話番号.E0006'
              );
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * お知らせダイアログ（共通）
     * @param {string} text ダイアログメッセージ
     */
    async callMessageDialog(text) {
      await this.$informationDialog(text);

      // アカウント管理(ユーザー情報)に遷移
      this.$router.back('userInfoAccountManagement');
    },
    /**
     * 確認ダイアログ
     */
    async callSaveAgreementDialogDialog() {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU47ユーザー情報変更画面氏名電話番号.C0002',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );
      if (result === true) {
        // はいを押すと更新処理実行
        if (isNaN(this.userInfo.birthyear)) {
          this.userInfo.birthyear = null;
        }
        this.APP_CU4702();
      }
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    this.birthyear = null;

    //何故か、以下通信でローディングマークを出してるので、ここで画面表示
    this.isShowPage = true;

    let param = '/api/changeUserInfoOfPersonalData/init';
    let method = 'post';

    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
      customerNumber: this.$store.state.customerNumber,
      districtSplitNumber: this.$store.state.districtSplitNumber,
    };
    await this.APP_CU4701(param, queries, method);
  },
};
